import React from 'react';
import loadable from '@loadable/component';
import { getDiscountList } from '../../../actions/discount';

export default {
	component: loadable(
		() => import(/* webpackChunkName: "discount" */ '../DiscountList'),
		{
			fallback: <div>Loading...</div>
		}
	)
};
